import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { queryClient } from "@/lib/queryClient";

export interface UserBilling {
  tier_id: string;
  status: string | null;
  stripe_subscription_id: string | null;
  current_period_end: string | null;
  pause_collection_set: boolean;
}

export function invalidateAdminUserBilling(userId: string) {
  return queryClient.invalidateQueries({ queryKey: ["admin-user-billing", userId] });
}

export function useAdminUserBilling(userId: string | null) {
  const query = useQuery({
    queryKey: ["admin-user-billing", userId],
    enabled: !!userId,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("admin_user_billing", {
        target_user_id: userId!,
      });
      if (error) throw error;
      return (data as UserBilling[] | null)?.[0] ?? null;
    },
    staleTime: 30_000,
  });

  return {
    data: query.data ?? null,
    billing: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
